import styled, { css } from 'styled-components';
import { ColorTheme, getTheme } from '../utils/colorTheme';
import { Container } from '../common';

export const Banner = styled.div<{ reverse?: boolean, theme?: ColorTheme }>`
    display: flex;
    padding: 100px 0;
    flex-direction: ${(p) => p.reverse ? 'row-reverse' : 'row'};
    ${(p) => getTheme(p.theme)};
    align-items: center;
    text-align: center;
    flex-direction: column;
    z-index: 1;

    ${Container} {
        flex-direction: column;
        max-width: 600px;
    }
`;
